import Api from "./patientsListApi";
import { combineFilters } from "./modulesCommon";
import { clone } from "../helpers";

const DATA = "DATA";
const DATA_LOADED = "DATA_LOADED";
const DATA_LOADING = "DATA_LOADING";
const MR_ATTRIBUTES = "MR_ATTRIBUTES";

const emptyDataObj = {
    patientsList: {}
};

const patientsListDataModule = {
    namespaced: true,
    state: () => ({
        data: clone(emptyDataObj),
        dataLoaded: null,
        dataLoading: false,
        mrAttributes: Object.create({}),
    }),
    
    mutations: {
        [DATA](state, data) { state.data = data; },
        [DATA_LOADED](state, isDataLoaded) { state.dataLoaded = isDataLoaded; },
        [DATA_LOADING](state, dataLoading) { state.dataLoading = dataLoading; },
        [MR_ATTRIBUTES](state, mrAttributes) { state.mrAttributes = mrAttributes; },
    },
    
    actions: {
        readData({ commit, state, rootState }, context) {
            let filters = combineFilters(rootState.patientQuery, rootState.caseQuery, rootState.advancedQueryCriteria);
            commit(DATA_LOADED, false);

            return Api.GetData(context, filters).then(function (result) {
                commit(DATA, result.data);
                commit(DATA_LOADED, true);
            });
        },
        // is data was loaded
        setDataLoaded({ commit }, isDataLoaded) {
            return commit(DATA_LOADED, isDataLoaded);
        },
        setDataLoading({ commit }, isDataLoading) {
            return commit(DATA_LOADING, isDataLoading);
        },
        cleanData({ commit }) {
            commit(DATA, clone(emptyDataObj));
            commit(DATA_LOADED, false);
        },
        readMrAttributes({ commit }) {
            return Api.GetMrAttributes().then((result) => {
                commit(MR_ATTRIBUTES, result.data);
            });
        },
    },
};

export default patientsListDataModule;